// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3bkE5","left":"InfoRow_left__3_TSX"};